export default __webpack_public_path__ + "static/4cebc7e1942c74057d2798a745b4fa06.webp";